import CitySEOHead from "@/components/feature/CitySEOHead";
import LakelandHeroSection from "./components/HeroSection";
import LakelandStickyNav from "./components/StickyNav";
import LakelandProcessingTimeSection from "./components/ProcessingTimeSection";
import LakelandServicesSection from "./components/ServicesSection";
import LakelandLocalAreaSection from "./components/LocalAreaSection";
import LakelandTestimonialsSection from "./components/TestimonialsSection";
import LakelandAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import LakelandComparisonSection from "./components/ComparisonSection";
import LakelandMistakesSection from "./components/MistakesSection";
import LakelandHowItWorksSection from "./components/HowItWorksSection";
import LakelandFAQSection from "./components/FAQSection";
import LakelandHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import LakelandFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const pageTitle = "Emergency Passport Lakeland, FL — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Lakeland, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Polk County travelers and Central Florida residents.";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

const faqs = [
  {
    q: "Where can I get an emergency passport in Lakeland today?",
    a: "For same-day emergency passport needs in Lakeland, you have two primary options. The Miami Passport Agency (1501 Biscayne Blvd Suite 210, Miami, FL 33132) is approximately 280 miles away via I-4 and I-75 — about a 4-hour drive each way. Appointments are required and are typically reserved for life-or-death emergencies with documented proof of travel within 72 hours. Alternatively, Fast Passport Center can process your passport in as little as 2–3 business days through our registered courier channel — no drive to Miami, no appointment required. Start your order online and we will confirm your timeline based on your travel date.",
  },
  {
    q: "What is the fastest way to get a passport in Lakeland?",
    a: "The fastest option for most Lakeland residents is Fast Passport Center's registered courier service. We submit your application through reserved daily agency slots and deliver your new passport within 2–9 business days depending on the service level you select. This is significantly faster than the Miami Passport Agency's appointment-only process, which requires a 4-hour drive via I-4 and I-75 plus an all-day wait at the agency. Standard government processing through a Lakeland post office takes 1–3 months. Start your order online and we will confirm the fastest available option for your travel date.",
  },
  {
    q: "Can I get a same-day passport in Lakeland?",
    a: "Same-day passport service is only available through a regional passport agency with an in-person appointment. The nearest regional agency to Lakeland is the Miami Passport Agency — approximately 280 miles via I-4 and I-75 (about 4 hours). The agency only serves travelers with life-or-death emergencies and documented travel within 72 hours. Appointments are extremely limited and must be secured through the NPIC scheduling system. Walk-ins are never accepted. For most Lakeland travelers who do not qualify for a same-day agency appointment, Fast Passport Center's 2–3 business day service is the fastest available option — no drive to Miami required.",
  },
  {
    q: "Is there a passport agency in Lakeland?",
    a: "No, there is no regional passport agency in Lakeland. The nearest regional passport agency is the Miami Passport Agency, located at 1501 Biscayne Blvd Suite 210, Miami, FL 33132 — approximately 280 miles from Lakeland via I-4 and I-75. Lakeland does have several passport acceptance facilities including USPS post offices on South Florida Avenue and Lakeland Highlands Road, but these are acceptance facilities only — they process standard applications that take 1–3 months. For expedited service, Fast Passport Center's registered courier channel provides the fastest available option without the 4-hour drive to Miami.",
  },
  {
    q: "What if I can't get a Lakeland passport agency appointment?",
    a: "If you cannot get an appointment at the Miami Passport Agency — which is common, as appointments are routinely booked 2–4 weeks out — Fast Passport Center is your most reliable alternative. Our registered courier service bypasses the appointment system entirely. We submit applications through reserved daily agency access and process passports in as little as 2–3 business days. You do not need an appointment, you do not need to drive 280 miles to Miami via I-4 and I-75, and you do not need documented proof of emergency travel. Simply start your order online, visit a local Lakeland acceptance facility, and ship your documents overnight. We handle the rest.",
  },
];

export default function LakelandPage() {
  return (
    <>
      <CitySEOHead
        city="Lakeland"
        state="Florida"
        stateAbbr="FL"
        route="/cities/lakeland"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Lakeland, Florida"
        geoPosition="28.0395;-81.9498"
        keywords="expedited passport Lakeland, emergency passport Lakeland FL, same day passport Lakeland, fast passport Polk County, passport renewal Lakeland, Lakeland passport courier"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
        lastModified="2026-06-14"
      />
      <div className="min-h-screen bg-white">
        <LakelandHeroSection />
        <LakelandStickyNav />
        <LakelandProcessingTimeSection />
        <LakelandServicesSection />
        <LakelandLocalAreaSection />
        <LakelandTestimonialsSection />
        <LakelandAcceptanceFacilitiesSection />
        <LakelandComparisonSection />
        <LakelandMistakesSection />
        <LakelandHowItWorksSection />
        <LakelandFAQSection />
        <LakelandHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/lakeland" state="FL" />
        <LakelandFinalCTA />
      </div>
    </>
  );
}